var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m22.4 2.828-.707-.707a1 1 0 0 0-1.415 0L2.803 19.596l.505-.504 2.121 2.121 16.97-16.97a1 1 0 0 0 0-1.415ZM6.136 21.92l16.97-16.97a2 2 0 0 0 0-2.829l-.706-.707a2 2 0 0 0-2.829 0L1.893 19.092l-1.06 4.596 4.596-1.06.707-.708Zm-1.54-.126-1.869-1.868-.56 2.428 2.428-.56Zm18.51-15.43a1 1 0 0 1 0 1.414l-5.656 5.657-.707-.707 6.364-6.364Z",
  fill: "#252829"
})));
export default SvgEditinline;